export const TIME_TRACKING_STATUS = {
  CLOCK_IN: 'Clock In',
  BREAK: 'Break',
  LUNCH_BREAK: 'Lunch Break',
  COACHING: 'Coaching',
  TRAININGS: 'Trainings',
  MEETINGS: 'Meetings',
  CLOCK_OUT: 'Clock Out'
}
